import type {
  Configuration,
  ListBillingTransactionHistoryRequest,
  QueryCostDataRequest,
} from '@repo/api-gw-sdk';
import { BillingApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/metering';

export const metering = (httpClient: HttpClient, config: Configuration) => {
  const billingApi = new BillingApi(config);

  return {
    useQueryCostData: (queryCostDataRequest: QueryCostDataRequest) =>
      httpClient.execute(
        billingApi.queryCostData.bind(billingApi),
        baseUrl,
        '',
        queryCostDataRequest
      ),
    useGetBillingTransactions: (
      request: ListBillingTransactionHistoryRequest
    ) =>
      httpClient.execute(
        billingApi.listBillingTransactions.bind(billingApi),
        baseUrl,
        '/billing-transactions',
        request
      ),
  };
};
